export default __webpack_public_path__ + "static/media/me.078239a2.svg";